import { produce } from "immer";

import {
  BannersActionsTypes,
  BannersReducerActions,
  BannersState
} from "../types/Banners.reducer.types";

const INITIAL_STATE: BannersState = {
  list: undefined,
  isLoadingList: false,
  message: undefined
};

export default function reducer(
  state = INITIAL_STATE,
  action: BannersReducerActions
): BannersState {
  return produce(state, draft => {
    switch (action.type) {
      case BannersActionsTypes.CREATE_REQUEST: {
        draft.message = undefined;
        break;
      }

      case BannersActionsTypes.CREATE_FAIL: {
        draft.message = action.payload.message;
        break;
      }

      case BannersActionsTypes.CREATE_SUCCESS: {
        draft.message = action.payload.message;
        break;
      }

      case BannersActionsTypes.DISMISS_MESSAGE: {
        draft.message = undefined;
        break;
      }

      case BannersActionsTypes.EDIT_REQUEST: {
        draft.message = undefined;
        break;
      }

      case BannersActionsTypes.EDIT_FAIL: {
        draft.message = action.payload.message;
        break;
      }

      case BannersActionsTypes.EDIT_SUCCESS: {
        draft.message = action.payload.message;
        break;
      }

      case BannersActionsTypes.LIST_REQUEST: {
        draft.isLoadingList = true;
        draft.list = undefined;
        break;
      }

      case BannersActionsTypes.LIST_FAIL: {
        draft.isLoadingList = false;
        draft.list = undefined;
        break;
      }

      case BannersActionsTypes.LIST_SUCCESS: {
        draft.isLoadingList = false;
        draft.list = action.payload.list;
        break;
      }
      default:
    }
  });
}
